import React, { useState } from "react";
import styled from "styled-components";
import MenuIcon from "@icons/Menu-TripleVerticalDots-Icon.svg";
import { FontSize } from "@themes/Fonts";
import Styles from "@themes/Styles";
import useOutsideClickTrigger from "../../hooks/useOutsideClickTrigger";
import LifeAtButton from "../LifeAtButton/LifeAtButton";
import StackedButton from "../LifeAtButton/Variants/StackedButton";

const MenuWrapper = styled.div``;

const MenuButton = styled(StackedButton)`
    padding: 4px;
    min-height: unset;
    border-radius: ${Styles.borderRadiusExtraSharp};

    &:hover {
        background-color: ${(props) => props.theme.hoverPrimary};
        * {
            background-color: ${(props) => props.theme.hoverPrimary};
        }
    }
`;

const MenuButtonIcon = styled(MenuIcon)`
    fill: ${(props) => props.theme.iconColor};
    vertical-align: baseline !important;
`;

const MenuContents = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;

    position: fixed;
    height: auto;
    min-width: 40px;
    width: auto;
    padding: 8px 0;

    background-color: ${(props) => props.theme.backgroundPrimary};
    border-radius: ${Styles.borderRadiusSharp};
    box-shadow: ${(props) => props.theme.boxShadow} ${(props) => props.theme.boxShadowColor};

    * {
        font-size: ${FontSize.normal};
    }
`;

export interface ActionDataModel {
    readonly name: string;
    readonly actionHandler: () => void;
}

interface MoreActionsMenuProps {
    readonly actions: ActionDataModel[];
    readonly overrideIcon?: JSX.Element;
    className?: string;
}
export default function MoreActionsMenu(props: MoreActionsMenuProps) {
    const menuRef = useOutsideClickTrigger(() => setShowMenu(false));

    const [showMenu, setShowMenu] = useState(false);

    const toggleShowMenu = () => {
        setShowMenu(!showMenu);
    };

    // Perform the action's logic, then close the menu.
    const handleAction = (handler: () => void) => {
        handler();
        setShowMenu(false);
    };

    return (
        <MenuWrapper className={`more-actions-menu-wrapper ${props.className}`} ref={menuRef}>
            <MenuButton action={"click"} icon={props.overrideIcon || <MenuButtonIcon />} handleClick={toggleShowMenu} />

            {showMenu && (
                <MenuContents className={`more-actions-menu-contents ${props.className}`}>
                    {props.actions.map((action) => {
                        return (
                            <MenuAction
                                key={`more-actions-menu-item-${action.name}`}
                                name={action.name}
                                actionHandler={() => handleAction(action.actionHandler)}
                            />
                        );
                    })}
                </MenuContents>
            )}
        </MenuWrapper>
    );
}

const ActionElement = styled(LifeAtButton)`
    font-size: ${FontSize.small};
    width: 100%;
    min-height: 24px;
    padding: 10px;
    border-radius: ${Styles.borderRadiusExtraSharp};

    &:hover {
        background-color: ${(props) => props.theme.hoverPrimary};
        * {
            background-color: ${(props) => props.theme.hoverPrimary};
        }
    }
`;

function MenuAction(props: ActionDataModel) {
    return <ActionElement isLink={false} text={props.name} handleClick={props.actionHandler} />;
}
